import Repository from '../axios'

const resource = '/admin/system_setting/ecd-settings'

export default {
  getECDSettings() {
    return Repository.get(resource)
  },
  saveECDSettings(payload) {
    return Repository.post(resource, payload)
  }
}
